export default __webpack_public_path__ + "static/media/404 Error with a cute animal-amico.98c46962.svg";